module.exports = __webpack_public_path__ + "static/media/house-large.d40cfe9a.png";